function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    // 动画
    $('#goods-image_header_1').show()
    $('#goods-image_header_2').hide()
    let header_flag = false
    setInterval(() => {
      header_flag = !header_flag
      if (header_flag) {
        $('#goods-image_header_1').hide()
        $('#goods-image_header_2').show()
      } else {
        $('#goods-image_header_1').show()
        $('#goods-image_header_2').hide()
      }
    }, 1000)
    // 走马灯
    new Swiper('.mySwiper', {
      loop: true,
      centeredSlides: true,
      spaceBetween: 17,
      slidesPerView: 3,
      freeMode: true,
      speed: 7000, //匀速时间
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop =
          targetElement.offsetTop 
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()




let spImgList = [
  "https://cdn.shopify.com/s/files/1/0793/9489/8193/files/202409212-o1.png?v=1726913958",
  "https://cdn.shopify.com/s/files/1/0793/9489/8193/files/202409212-o2.png?v=1726913958",
  "https://cdn.shopify.com/s/files/1/0793/9489/8193/files/202409212-o3.png?v=1726913957",
  "https://cdn.shopify.com/s/files/1/0793/9489/8193/files/202409212-o4.png?v=1726913957",
];
$(".sp-option").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  // style选项

  let colorOptions = $("#sp-color1 .sp-option.active").index();
  let colorOptions2 = $("#sp-color2 .sp-option.active").index();
  let colorOptions3 = $("#sp-color3 .sp-option.active").index();
  let colorOptions4 = $("#sp-color4 .sp-option.active").index();
  let colorOptions5 = $("#sp-color5 .sp-option.active").index();
  $("#spimg1")[0].src = spImgList[colorOptions];
  $("#spimg2")[0].src = spImgList[colorOptions2];
  $("#spimg3")[0].src = spImgList[colorOptions3];
  $("#spimg4")[0].src = spImgList[colorOptions4];
  $("#spimg5")[0].src = spImgList[colorOptions5];
});
$(".sp-btn-more").click(function () {
  $(".sp-mask").css("display", "flex");
});


$(".sp-btn-style3 ,.sp-close-btn").click(function () {
  $(".sp-mask").hide();
});
let select_num = 3
$('.sp-option-5').hide()
$('.sp-btn-more3').click(function () {
  $('.sp-option-5').hide()
  select_num = 3
});
$('.sp-btn-more5').click(function () {
  $('.sp-option-5').show()
  select_num = 5
});
$(".buy1").click(function () {
  let id = $(".sp-color-wrap .active").attr("data-id");
  window.location.href = "/cart/" + id + ":" + 1;
});
$(".buy-more").click(function () {
  if(select_num == 3){
    let id1 = $("#sp-color1 div.active").attr("data-id");
    let id2 = $("#sp-color2 div.active").attr("data-id");
    let id3 = $("#sp-color3 div.active").attr("data-id");
    window.location.href = `/cart/${id1}:1,${id2}:1,${id3}:1`
  }else if(select_num == 5){
    let id1 = $("#sp-color1 div.active").attr("data-id");
    let id2 = $("#sp-color2 div.active").attr("data-id");
    let id3 = $("#sp-color3 div.active").attr("data-id");
    let id4 = $("#sp-color4 div.active").attr("data-id");
    let id5 = $("#sp-color5 div.active").attr("data-id");
    window.location.href = `/cart/${id1}:1,${id2}:1,${id3}:1,${id4}:1,${id5}:1`
  }
});
$(".sp-color").click(function () {
  $(this).siblings().removeClass("active");
  $(this).addClass("active");
  let colorOptions = $(".sp-color-wrap .sp-color.active").index();
  $("#colorImg")[0].src = spImgList[colorOptions];
});
